import { SearchesService } from '../services'

const exportSearches = (filters) => {
  return new Promise(async (resolve, reject) => {
    await SearchesService.exportExcel(filters)
      .then(response => resolve(response.data))
      .catch(err => reject(err))
  })
}

export default exportSearches
